//２点間の距離
const getDistance = (pointA, pointB) => {
  return Math.sqrt(Math.pow(pointA.x - pointB.x, 2) + Math.pow(pointA.y - pointB.y, 2))
}

//２点の角度
const getDegree = (pointA, pointB) => {
  return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * (180 / Math.PI)
}

//角度をラジアンに変更
const degreeToRadian = (degree) => {
  return degree * (Math.PI / 180)
}

//ラジアンを角度に変更
const radianToDegree = (radian) => {
  return radian / (Math.PI / 180)
}

const MathUtil = {
  getDistance: getDistance,
  getDegree: getDegree,
  degreeToRadian: degreeToRadian,
  radianToDegree: radianToDegree,
}
export default MathUtil
